import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { translate } from "react-translate";
import ListPractices from 'components/ListPractices/ListPractices';
//import ListPractices from 'components/ListPractices/testHooks';

const Practice = (props) => {
  const {t} = props;
  
  return (
    <div className='content user-manual'>
      <Card>
        <CardHeader>
          <h5 className="title">{t("title-header")}</h5>
        </CardHeader>
        <CardBody>
          <ListPractices />
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("practiceList")(Practice);
